/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Svc_Card_ExploreInputs */

const en_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explore spec`)
};

const ar_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`استكشف المواصفة`)
};

const bn_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`স্পেক এক্সপ্লোর করুন`)
};

const de_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spezifikation erkunden`)
};

const es_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar especificaciones`)
};

const fr_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorer les spécifications`)
};

const pt_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Explorar especificações`)
};

const zh_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`探索规范`)
};

const tr_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Spesifikasyonları keşfedin`)
};

const ru_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Открыть спек`)
};

const pl_svc_card_explore = /** @type {(inputs: Svc_Card_ExploreInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Poznaj specyfikację`)
};

/**
* | output |
* | --- |
* | "Explore spec" |
*
* @param {Svc_Card_ExploreInputs} inputs
* @param {{ locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }} options
* @returns {LocalizedString}
*/
export const svc_card_explore = /** @type {((inputs?: Svc_Card_ExploreInputs, options?: { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Svc_Card_ExploreInputs, { locale?: "en" | "ar" | "bn" | "de" | "es" | "fr" | "pt" | "zh" | "tr" | "ru" | "pl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ar") return ar_svc_card_explore(inputs)
	if (locale === "bn") return bn_svc_card_explore(inputs)
	if (locale === "de") return de_svc_card_explore(inputs)
	if (locale === "es") return es_svc_card_explore(inputs)
	if (locale === "fr") return fr_svc_card_explore(inputs)
	if (locale === "pt") return pt_svc_card_explore(inputs)
	if (locale === "zh") return zh_svc_card_explore(inputs)
	if (locale === "tr") return tr_svc_card_explore(inputs)
	if (locale === "ru") return ru_svc_card_explore(inputs)
	if (locale === "pl") return pl_svc_card_explore(inputs)
	return en_svc_card_explore(inputs)
});